import { NgxMaskModule } from "ngx-mask";
import { MatRadioModule } from "@angular/material/radio";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID, APP_INITIALIZER } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSelectModule } from "@angular/material/select";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatDividerModule } from "@angular/material/divider";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatStepperModule } from "@angular/material/stepper";
import { MatDialogModule } from "@angular/material/dialog";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatTabsModule } from "@angular/material/tabs";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatExpansionModule } from "@angular/material/expansion";
import { MainNavComponent } from "./main-nav/main-nav.component";
import { LayoutModule } from "@angular/cdk/layout";
import { HomeComponent } from "./pages/home/home.component";
import { NotFoundComponent } from "./pages/not-found/not-found.component";
import { MatInputModule } from "@angular/material/input";
import { MatCardModule } from "@angular/material/card";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { LoginComponent } from "./pages/login/login.component";
import { WaitComponent } from "./pages/wait/wait.component";
// import { SnowfModule } from 'ngx-snowf';
import { AdminComponent } from "./pages/admin/admin.component";
// import { OutofofficeComponent } from "./pages/outofoffice/outofoffice.component";
import { DialogLeaveDetail } from "./pages/outofoffice/dialog-leave-detail";
import { DashboardModule } from "./pages/outofoffice/dashboard.module";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { AuthGuard } from "./pages/auth/auth.guard";
import { AuthService } from "./services/auth.service";
import { LicenseComponent } from "./license/license.component";
import { ApprovalTrackComponent } from "./pages/approvaltrack/approvaltrack.component";
import { InandoutComponent } from "./pages/inandout/inandout.component";
import { MailApproveComponent } from "./pages/mail-approve/mail-approve.component";

import { SafeResourceScript } from "./pages/outofoffice/sanitize-script.pipe";
import { NgxPrintModule } from "ngx-print";
import { DelegationComponent } from "./pages/delegation/delegation.component";
import { ConfirmationDialog } from "./pages/confirmation/confirmation-dialog.component";
import { MatTableExporterModule } from "mat-table-exporter";
import { TextMaskModule } from "../../node_modules/angular2-text-mask";

import { DocumentComponent } from "./pages/document/document.component";
import { MonthlyCalcComponent } from "./pages/monthly-calc/monthly-calc.component";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { FileUploadComponent } from "./pages/document/file-upload.component";
import { ListComponent } from "./pages/document/list.component";
import { ViewComponent } from "./pages/document/view.component";
import { PoolService } from "./services/pool.service";
import { MediaMatcher } from "@angular/cdk/layout";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { StepperNavigationComponent } from "./components/stepper-navigation/stepper-navigation.component";
import { JwtInterceptor } from "./services/jwtinterceptor";
import { ErrorInterceptor } from "./services/errinterceptor";
import { AppConfigService } from "./services/app-config.service";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./auth/reset-password/reset-password.component";
// import { RemoteWorkSchedulerComponent } from "./components/remote-work-scheduler/remote-work-scheduler.component";
import { ManualMovementDialogComponent } from "./pages/inandout/manual-movement-dialog.component";
import { SafePipe } from "./pages/outofoffice/sanitize-html.pipe";

export function initializeApp(appConfigService: AppConfigService) {
  return () => appConfigService.loadConfig();
}

@NgModule({
  declarations: [
    SafePipe,
    SafeResourceScript,
    DialogLeaveDetail,
    AppComponent,
    MainNavComponent,
    HomeComponent,
    NotFoundComponent,
    LoginComponent,
    WaitComponent,
    AdminComponent,
    // OutofofficeComponent,
    LicenseComponent,
    ApprovalTrackComponent,
    InandoutComponent,
    DocumentComponent,
    MailApproveComponent,
    DelegationComponent,
    FileUploadComponent,
    ListComponent,
    ConfirmationDialog,
    // ShiftSchedulerComponent,
    MonthlyCalcComponent,
    ViewComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ManualMovementDialogComponent,
  ],
  imports: [
    // SnowfModule,
    // FlexLayoutModule,

    MatRadioModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    DashboardModule,
    TextMaskModule,
    NgxMaterialTimepickerModule,
    NgxMaskModule.forRoot(),
    MatTableExporterModule,
    NgxPrintModule,
    MatSelectModule,
    MatExpansionModule,
    MatStepperModule,
    MatAutocompleteModule,
    MatDividerModule,
    MatBottomSheetModule,
    MatGridListModule,
    MatSnackBarModule,
    MatTabsModule,
    MatMenuModule,
    MatDialogModule,
    DragDropModule,
    MatCardModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  entryComponents: [
    WaitComponent,
    DialogLeaveDetail,
    ConfirmationDialog,
    ListComponent,
    ViewComponent,
    ManualMovementDialogComponent,
  ],

  providers: [
    AppConfigService,
    MediaMatcher,
    PoolService,
    AuthService,
    AuthGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // { provide: 'apiUrl', useValue: 'http://localhost:5110/' },
    // { provide: 'apiUrl', useValue: 'http://192.168.0.170/BcsApp/' },
    // { provide: 'apiUrl', useValue: 'http://uzaktancalisma.ipekyol.com.tr/BcsApp/' },
    // { provide: 'apiUrl', useValue: 'http://10.84.8.28:2021/BcsApp/' },
    // { provide: 'apiUrl', useValue: 'http://uzaktancalisma.ipekyol.com.tr/BcsApp/' },
    // { provide: 'apiUrl', useValue: 'http://10.61.1.76:1996/BcsApp/' },
    // { provide: 'apiUrl', useValue: 'http://pdks:2016/BcsApp/' },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    //  { provide: LOCALE_ID, useValue: 'tr-TR'}
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));
